import { FC } from "react";
import { Logo } from "src/icons/Logo";
import { StyledLogoHeaderWrapper, StyledLogoHeader } from "./LogoHeader.styled";
import Link from "next/link";

const LogoHeader: FC = () => (
  <StyledLogoHeaderWrapper>
    <StyledLogoHeader>
      <Link href="/">
        <Logo />
      </Link>
    </StyledLogoHeader>
  </StyledLogoHeaderWrapper>
);

export default LogoHeader;
